import React from 'react';
import {Col, Container, Row, Card, CardBody, Button, ButtonGroup, Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';
import {connect} from 'react-redux';
import LoadingProgress from '../../components/LoadingProgress'
import ReactQueryParams from 'react-query-params';
import {ButtonToolbar} from 'reactstrap';
import {withRouter} from 'react-router-dom';
import Alert from '../../components/Alert';
import DateSelector from '../../components/DateSelector'
import * as TextManager from "../../modules/languages/TextManager";
import {fetchUserHistoryDataIfNeeded} from "../../redux/actions/UserHistoryActions";
import classnames from 'classnames';
import EnteringsTable from './components/EnteringsTable'






export class UserHistory extends ReactQueryParams {
    constructor(props) {
        super(props);
        this.state = {
            searchValue: '',
            activeTab: '1',
        };
    }

    componentDidMount() {
        this.props.dispatch(fetchUserHistoryDataIfNeeded(this.queryParams));
    }

    toggle = (tab) => {
        if (this.state.activeTab !== tab) {
            this.setState({
                activeTab: tab,
            });
        }
    };

    changeSearch = (e) => {
        this.setState({searchValue: e.target.value});
    };

    filterDataBySearch = record => {
        //console.log(record);
        if (this.state.searchValue === undefined || this.state.searchValue === null || this.state.searchValue === "") {
            return true;
        } else {
            let matchingRecords = Object.values(record ? record : {});

            let retVal = false;
            matchingRecords.forEach(mr => {
                // debugger;
                if (typeof mr === 'string') {
                    if (mr.toLowerCase().includes(this.state.searchValue.toLowerCase())) {
                        retVal = retVal || true;
                    }
                } else if (typeof mr === 'number') {
                    if (parseInt(this.state.searchValue) === mr) {
                        retVal = retVal || true;
                    }
                } else if (typeof mr === 'object') {
                    retVal = retVal || this.filterDataBySearch(mr);
                }
            });
            return retVal;
        }
    };

    render() {

        let sign_in = []; //this.props.data.stat;

        if (this.props.data && this.props.data.signIn) {
            sign_in = this.props.data.signIn;
        }

        if (this.state.searchValue !== '' && this.state.activeTab === '1') {
            sign_in = this.props.data.signIn.filter(this.filterDataBySearch)
        }



        return (
            <Container className='dashboard'>

                {this.props.status === 'request' &&
                <Row>
                    <LoadingProgress/>
                </Row>
                }

                {this.props.status === 'error' &&
                <Row>
                    <Alert color='danger' className='alert--bordered' icon>
                        <p><span className='bold-text'>{TextManager.getCurrentTextResource().Text.error}</span></p>
                        <p>{TextManager.getCurrentTextResource().Text.unexpectedServerError}</p>
                    </Alert>
                </Row>
                }

                {this.props.status === 'no_permission' &&
                <Row>
                    <Alert color='warning' className='alert--bordered' icon>
                        <p><span className='bold-text'>{TextManager.getCurrentTextResource().Text.loginFailed}</span>
                            {TextManager.getCurrentTextResource().Text.pleaseRefreshThePage}</p>
                    </Alert>
                </Row>
                }

                {this.props.status === 'success' &&
                <span>
                    <Row>
                        <Col md={12}>
                            <Card>
                              <CardBody>
                                <div className="card__title">
                                  <h3 style={{textAlign: 'right'}}>היסטוריית המשתמשים</h3>
                                </div>
                                  <div style={{padding: "1.25rem"}}>
                                      {/*this.state.activeTab === '2' && <div style={{display: 'flex', height: '100%', width: '70%'}}>
                                          <ButtonToolbar className='custom_dashboard_header_panel'>
                                              <DateSelector endpoint='orders'/>
                                              <MultiSelectionFilter items={statusLst} name="סטטוס" queryParam="status"/>
                                          </ButtonToolbar>
                                      </div> */}
                                      {this.state.activeTab === '1' && <div style={{display: 'flex', height: '100%', justifyContent: 'flex-end'}}>
                                          <ButtonToolbar className='custom_dashboard_header_panel'>
                                              <form className='topbar__search material-form'>
                                                  <div
                                                      className='search_field_form_control material-form__field topbar__search-field'>
                                                      <div className='search_field_root search_field_custom-underline'
                                                           style={{border: 'groove'}}>
                                                          <input className='search_field_custom-input' dir="rtl"
                                                                 placeholder={TextManager.getCurrentTextResource().Text.searchByNameOrID}
                                                                 value={this.state.searchValue}
                                                                 onChange={(e) => this.changeSearch(e)}/>
                                                      </div>
                                                  </div>
                                              </form>
                                          </ButtonToolbar>
                                      </div>}
                                  </div>
                                  <div className="tabs tabs--bordered-top">
                                      <div className="tabs__wrap" style={{direction: 'rtl'}}>
                                        <Nav tabs>
                                          <NavItem>
                                            <NavLink
                                                className={classnames({ active: this.state.activeTab === '1' })}
                                                onClick={() => {
                                                    this.toggle('1');
                                                }}
                                            >
                                              כניסות
                                            </NavLink>
                                          </NavItem>
                                            {/*<NavItem>
                                            <NavLink
                                                className={classnames({ active: this.state.activeTab === '2' })}
                                                onClick={() => {
                                                    this.toggle('2');
                                                }}
                                            >
                                              סימים במלאי לכל חנות
                                            </NavLink>
                                          </NavItem>*/}
                                        </Nav>
                                        <TabContent activeTab={this.state.activeTab}>
                                          <TabPane tabId="1" style={{direction: 'ltr'}}>
                                              <EnteringsTable data={sign_in}/>
                                          </TabPane>
                                            {/*<TabPane tabId="2" style={{direction: 'ltr'}}>
                                            <OrdersTableStat data={stats}/>
                                          </TabPane>
                                          <TabPane tabId="3" style={{direction: 'ltr'}}>
                                              {isManager && <OrderForm/>}
                                          </TabPane>*/}
                                        </TabContent>
                                      </div>
                                    </div>
                              </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </span>
                }

            </Container>
        )
    }
}


const mapStateToProps = (state) => {
    return {
        status: state.userHistory.status,
        data: state.userHistory.data,
        userData: state.userData,
        utilsData: state.utilsData
    };
};

export default withRouter(connect(mapStateToProps)(UserHistory))